import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/WeddingWalletSection.css';

const WALLET_ITEMS = [
    'paidGifts',
    'pendingInstallments',
    'failedPayments',
    'guestMessages',
    'totalCollected',
    'expectedPayments',
    'availableBalance',
] as const;

const WeddingWalletSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="landing-section" aria-labelledby="wallet-heading">
            <div className="landing-container">
                <SectionHeader
                    title={t('wallet.title')}
                    subtitle={t('wallet.subtitle')}
                    id="wallet-heading"
                />
                <ul className="wedding-wallet__list">
                    {WALLET_ITEMS.map((item) => (
                        <li key={item} className="wedding-wallet__item landing-card">
                            <span className="wedding-wallet__check" aria-hidden="true">✓</span>
                            <span>{t(`wallet.items.${item}`)}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default WeddingWalletSection;
